// src/hooks/useValidarQr.js
import { useEffect, useState } from 'react';
import  qrService  from '../service/qrService';

export default function useValidarQr(arg1, arg2, arg3) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Si arg3 está definido: arg1 = tipo, arg2 = personaId, arg3 = id
  // Si no: arg1 = personaId, arg2 = id (habilitación legado)
  const tipo = arg3 !== undefined ? arg1 : null;
  const personaId = arg3 !== undefined ? arg2 : arg1;
  const id = arg3 !== undefined ? arg3 : arg2;

  useEffect(() => {
    if (!personaId || !id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const result = tipo
          ? await qrService(tipo, personaId, id)
          : await qrService(personaId, id);
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [tipo, personaId, id]);

  return { data, loading, error };
}
